if (window.location.pathname === '/') {
  window.onscroll = function (e) {
    if (document.getElementById("navBar")) {
      if (window.pageYOffset > 80) {
        document.getElementById("navBar").classList.add("navbar-scroll");
      } else {
        document.getElementById("navBar").classList.remove("navbar-scroll");
      }
    }
  }
}

$('#faqScroll1').click(function () {
  $('#faqPremium').collapse('hide');
  $('#faqEssencial').collapse('hide');
  $('#faqGold').collapse('show');
  let elmnt = document.getElementById("faqEssencial");
  elmnt.scrollIntoView();

});

$('#faqScroll2').click(function () {
  $('#faqEssencial').collapse('hide');
  $('#faqGold').collapse('hide');
  $('#faqPremium').collapse('show');
  let elmnt = document.getElementById("faqPremium");
  elmnt.scrollIntoView();

});

$('#faqScroll3').click(function () {
  $('#faqEssencial').collapse('hide');
  $('#faqPremium').collapse('hide');
  $('#faqGold').collapse('show');

  let elmnt = document.getElementById("faqGold");
  elmnt.scrollIntoView();
});

$(document).on( 'submit', '#parceiros form', (e) => {
  e.preventDefault();
  e.stopPropagation();
  $(e.target).find('button').prop('disabled', true);
  let url = $(e.target).attr('data-action');
  $.ajax({
    type:'POST',
    url: url,
    data: new FormData(e.target),
    dataType: 'JSON',
    contentType: false,
    cache: false,
    processData: false,
    success:function(response) {
      if (response.success) {
        $(e.target).trigger("reset");
        $(e.target)
          .find('.alert-success')
          .removeClass('d-none')
          .html('Ótimo ! Enviamos para nossa equipe, em breve nosso time entrará em contato.');
      } else {
        $(e.target)
        .find('.alert-danger')
        .removeClass('d-none')
        .html('Ops ! Ocorreu algum problema no envio do formulário !');
      }
      $(e.target).find('button').prop('disabled', false);
    },
    error: function(response) {
      $(e.target)
        .find('.alert-danger')
        .removeClass('d-none')
        .html('Ops ! Ocorreu algum problema no envio do formulário !');
      $(e.target).find('button').prop('disabled', false);
    }
  });
});

// Scroll suave
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

$(document).on('click', '#tr4ctor-whatsapp-plug-icon', (e) => {
  e.preventDefault();
  if (typeof gtag_report_conversion === 'function') {
    gtag_report_conversion(e.target.href);
  } else {
    window.location = e.target.href;
  }
})
